import { Download, Plus } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

import { api } from "@/api";
import { ColorBar, STATUS, errText } from "@/components/prospect/common";
import { NewFileDialog } from "@/components/prospect/NewFileDialog";
import { toast } from "sonner";

export function FilesTab({ admin, onOpen }) {
  const [files, setFiles] = useState(null);
  const [status, setStatus] = useState("");
  const [creating, setCreating] = useState(false);
  const [agents, setAgents] = useState([]);
  const load = useCallback(() => api.get("/prospect/files", { params: { status } }).then(({ data }) => setFiles(data)).catch((e) => toast.error(errText(e))), [status]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (admin) api.get("/prospect/stats/agents").then(({ data }) => setAgents(data)).catch(() => {}); }, [admin, files]);
  return (
    <div data-testid="prospect-files-tab">
      <div className="ps-toolbar">
        <select className="pl-select" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="files-status-filter"><option value="">Tous les statuts</option>{Object.entries(STATUS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        {admin && <button type="button" className="primary-button" onClick={() => setCreating(true)} data-testid="create-file-btn"><Plus size={15} /> Créer un fichier</button>}
      </div>
      {admin && agents.length > 0 && (
        <div className="ps-agents" data-testid="agent-stats">
          {agents.map((a) => <div key={a.agent_id} className="ps-agent"><strong>{a.agent_name}</strong><small>{a.files} fichier(s) · {a.progress}% traités</small><span className="ps-agent-kpis" data-testid={`agent-kpis-${a.agent_id}`}><b>{a.calls}</b> appel{a.calls > 1 ? "s" : ""} · <b>{a.rdv}</b> RDV · <b>{a.opportunities}</b> opportunité{a.opportunities > 1 ? "s" : ""}</span><ColorBar counts={a.counts} total={a.total} /></div>)}
        </div>
      )}
      <table className="ps-table" data-testid="files-table">
        <thead><tr><th>Nom</th><th>Régions</th><th>Lignes</th><th>Agent</th><th>Créé le</th><th>Statut</th><th>Avancement</th><th /></tr></thead>
        <tbody>
          {files?.map((f) => (
            <tr key={f.id} onClick={() => onOpen(f.id)} className="ps-click" data-testid={`file-row-${f.id}`}>
              <td><strong>{f.name}</strong></td><td>{(f.regions.length ? f.regions : f.departments).join(", ") || "Toutes"}</td>
              <td>{f.total.toLocaleString("fr-FR")} / {f.size.toLocaleString("fr-FR")}</td><td>{f.agent_name || <em className="pl-muted">Non assigné</em>}</td>
              <td>{new Date(f.created_at).toLocaleDateString("fr-FR")}</td><td><span className={`ps-status st-${f.status}`}>{STATUS[f.status]}</span></td>
              <td className="ps-prog"><ColorBar counts={f.counts} total={f.total} /><small>{f.progress}% · RDV {f.rdv_rate}%</small></td>
              <td><a href={`${process.env.REACT_APP_BACKEND_URL}/api/prospect/files/${f.id}/export?fmt=xlsx`} onClick={(e) => e.stopPropagation()} aria-label="Exporter" data-testid={`file-export-${f.id}`}><Download size={15} /></a></td>
            </tr>
          ))}
        </tbody>
      </table>
      {files?.length === 0 && <p className="pl-muted ps-empty" data-testid="files-empty">Aucun fichier pour l'instant. Créez une règle dans Paramètres ou un fichier manuel.</p>}
      {creating && <NewFileDialog onClose={() => setCreating(false)} onCreated={() => { setCreating(false); load(); }} />}
    </div>
  );
}
